<template>
  <div id="drawer-title">
    <i id="title-icon" v-if="icon" :class="'dx-icon-' + icon"/>
    <div id="title" v-if="title">
      {{ title }}
    </div>
  </div>
</template>

<script setup>
  const props = defineProps(['title', 'icon'])
</script>

<style scoped lang="scss">
  #drawer-title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;

    transition: opacity 300ms;

    #title-icon {
      font-size: 1.5rem;
    }

    #title {
      font-size: 1rem;
    }
  }
</style>
